// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"6":"887890a06aead75c3a64","270":"afd85dadd5c46462756d"}[chunkId] + ".js";
};